export const ELLIPSIS = '…'

const range = (start, end) => {
  const result = []
  for (let i = start; i <= end; i += 1) {
    result.push(i)
  }
  return result
}

// Returns 0-indexed page numbers interleaved with ELLIPSIS tokens for the gaps.
// Always keeps the first and last page, plus siblingCount pages either side of
// currentPage. When the page count is small enough to show every page, all
// pages are returned with no ellipses.
const paginationRange = (currentPage, numPages, siblingCount = 2) => {
  const firstPageIndex = 0
  const lastPageIndex = numPages - 1

  // first + last + current + 2*siblings + 2 ellipsis slots
  const totalPageNumbers = siblingCount * 2 + 5

  if (numPages <= totalPageNumbers) {
    return range(0, lastPageIndex)
  }

  const leftSiblingIndex = Math.max(currentPage - siblingCount, firstPageIndex)
  const rightSiblingIndex = Math.min(currentPage + siblingCount, lastPageIndex)

  const showLeftEllipsis = leftSiblingIndex > firstPageIndex + 1
  const showRightEllipsis = rightSiblingIndex < lastPageIndex - 1

  if (!showLeftEllipsis && showRightEllipsis) {
    const leftItemCount = 3 + 2 * siblingCount
    return [...range(0, leftItemCount - 1), ELLIPSIS, lastPageIndex]
  }

  if (showLeftEllipsis && !showRightEllipsis) {
    const rightItemCount = 3 + 2 * siblingCount
    return [firstPageIndex, ELLIPSIS, ...range(numPages - rightItemCount, lastPageIndex)]
  }

  return [
    firstPageIndex,
    ELLIPSIS,
    ...range(leftSiblingIndex, rightSiblingIndex),
    ELLIPSIS,
    lastPageIndex,
  ]
}

export default paginationRange
